import { useEffect, useState } from "react";

const MOBILE_QUERY = "(max-width: 768px)";
const INITIAL_MOTION_DELAY_MS = 2800;
const MOTION_START_EVENTS: Array<keyof WindowEventMap> = [
  "scroll",
  "pointerdown",
  "keydown",
  "touchstart",
];

export function useHeroPartnerMotionReady() {
  const [motionReady, setMotionReady] = useState(false);

  useEffect(() => {
    if (!window.matchMedia(MOBILE_QUERY).matches) {
      setMotionReady(true);
      return;
    }

    let timeoutId: number | undefined;
    let removeMotionListeners = () => {};
    const enableMotion = () => {
      setMotionReady(true);
      if (timeoutId !== undefined) {
        window.clearTimeout(timeoutId);
      }
      removeMotionListeners();
    };
    const options: AddEventListenerOptions = { once: true, passive: true };
    timeoutId = window.setTimeout(enableMotion, INITIAL_MOTION_DELAY_MS);

    for (const eventName of MOTION_START_EVENTS) {
      window.addEventListener(eventName, enableMotion, options);
    }

    removeMotionListeners = () => {
      for (const eventName of MOTION_START_EVENTS) {
        window.removeEventListener(eventName, enableMotion);
      }
    };

    return removeMotionListeners;
  }, []);

  return motionReady;
}
